<template>
  <div class="legend">
    <div class="legend-title">{{title}}</div>
    <LegendEntry
      class="legend-item"
      :name="l.name" :color="l.color" v-for="(l, i) in entries" v-bind:key="i"/>
  </div>
</template>

<script>
import LegendEntry from './LegendEntry';

export default {
  name: 'Legend',
  components: { LegendEntry },
  props: {
    title: {
      type: String,
      default: ''
    },
    entries: {
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};
</script>

<style scoped lang="scss">
  @import "../style/color_";

  .legend {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1rem;
    color: $color-secondary;
    padding: 8px 0;
  }

  .legend-item {
    flex: 0 1 auto;
    text-align: center;
  }

  .legend-title {
    flex: 1 1 auto;
  }
</style>
